// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2y-q";
export var animationRelative = "_2y-p";
export var backdropBlur = "_2y-0";
export var detailLabelCell = "_2y-12";
export var detailTable = "_2y-11";
export var detailValueCell = "_2y-13";
export var docIconBox = "_2y-1d";
export var docIconBoxMd = "_2y-1f";
export var docIconBoxSm = "_2y-1e";
export var docTypeRow = "_2y-16";
export var docTypeRowInner = "_2y-17";
export var dropdownMatchDatePicker = "_2y-3";
export var evidenceCardContent = "_2y-1c";
export var fileUploadSpin = "_2y-j";
export var gorgiasOpenButton = "_2y-15 _2y-d";
export var gorgiasTicketCard = "_2y-14";
export var heroModalFooterButton = "_2y-18";
export var hiddenContainer = "_2y-o";
export var iconPrimary = "_2y-1g";
export var iconSecondary = "_2y-1h";
export var iconTertiary = "_2y-1i";
export var integrationCard = "_2y-1";
export var integrationLogoBox = "_2y-2";
export var mainColumnSticky = "_2y-1b";
export var maxWidthContainer = "_2y-19";
export var modalContentBody = "_2y-a";
export var modalHeaderImage = "_2y-5";
export var modalImageLabel = "_2y-7";
export var modalImageOverlay = "_2y-6";
export var modalImageSubtitle = "_2y-9";
export var modalImageTitle = "_2y-8";
export var modalImageWrapper = "_2y-4";
export var modalStickyFooter = "_2y-b";
export var removeButton = "_2y-e";
export var sidebarColumn = "_2y-1a";
export var spinner = "_2y-i";
export var timelineLine = "_2y-y";
export var timelineLineBlack = "_2y-10 _2y-y";
export var timelineLineGray = "_2y-z _2y-y";
export var timelineLineHeight = "_2y-x";
export var tlDotActivate = "_2y-u";
export var tlDotActivateAnim = "_2y-t";
export var tlDotHide = "_2y-s";
export var tlDotHideAnim = "_2y-r";
export var tlLineActivate = "_2y-w";
export var tlLineActivateAnim = "_2y-v";
export var uploadHint = "_2y-n";
export var uploadIconBox = "_2y-k";
export var uploadLabel = "_2y-m";
export var uploadText = "_2y-l";
export var uploadZone = "_2y-f";
export var uploadZoneCursorDefault = "_2y-h";
export var uploadZoneCursorPointer = "_2y-g";
export var uploadedFileRow = "_2y-c";
export var viewButton = "_2y-d";